import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Button, Row, Col, Form } from "antd";
import { BoilerOptions } from "../../../../Data/data";

const AddBoilerModal = ({ visible, onOk, onCancel, responeData, errors }) => {
  const [form] = Form.useForm();
  const [selectedParams, setSelectedParams] = useState([
    "runningHours",
    "totalRunningHours",
    "boilerPressure",
    "fuelPressure",
    "fdFanCurrent",
    "boilerLoad",
    "fuelOilType",
  ]);

  const [customParams, setCustomParams] = useState([
    { name: "Steam Pressure", unit: "bar" },
    { name: "Water Level", unit: "%" },
  ]);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    if (responeData) {
      form.setFieldsValue({
        title: responeData?.title || "",
        make: responeData?.boiler_make || "",
        model: responeData?.boiler_model || "",
        capacity: responeData?.boiler_capacity || "",
      });

      setSelectedParams(responeData?.selected_parameters || selectedParams);
      setCustomParams(
        Array.isArray(responeData?.other_parameters) ? responeData?.other_parameters : []
      );
    }
  }, [responeData, form]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const fieldErrors = Object.keys(errors).map((key) => ({
        name: key,
        errors: [errors[key]],
      }));
      form.setFields(fieldErrors);
    }
  }, [errors, form]);

  useEffect(() => {
    const hasEmptyFields = customParams.some(
      (param) =>
        !param.name.trim() || !param.unit.trim() || param.name.length > 50 || param.unit.length > 10
    );
    form
      .validateFields()
      .then(() => setIsFormValid(!hasEmptyFields))
      .catch(() => setIsFormValid(false));
  }, [customParams, form]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "", unit: "" }]);
  };

  const handleCustomChange = (index, field, value) => {
    const updated = [...customParams];
    updated[index][field] = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    const updated = [...customParams];
    updated.splice(index, 1);
    setCustomParams(updated);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const data = {
          ...values,
          selectedParams,
          customParams,
        };

        try {
          onOk(data);
        } catch (err) {
          console.error("Submit error:", err?.message || JSON.stringify(err));
        }
      })
      .catch((err) => {
        // Validation error fallback
        console.error("Validation failed:", err?.message || JSON.stringify(err));
      });
  };

  return (
    <Modal
      title="Add Boiler"
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText="OK"
      okButtonProps={{ disabled: !isFormValid }}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Boiler Name"
          name="title"
          rules={[{ required: true, message: "Please enter a title" }]}
        >
          <Input placeholder="Boiler Title" maxLength={50} />
        </Form.Item>

        <Form.Item
          label="Boiler Maker"
          name="make"
          rules={[{ required: true, message: "Please enter a make" }]}
        >
          <Input placeholder="Boiler Make" maxLength={50} />
        </Form.Item>

        <Form.Item
          label="Boiler Model"
          name="model"
          rules={[{ required: true, message: "Please enter a model" }]}
        >
          <Input placeholder="Boiler Model" maxLength={50} />
        </Form.Item>

        <Form.Item
          label="Boiler Capacity"
          name="capacity"
          rules={[{ required: true, message: "Please enter a Capacity" }]}
        >
          <Input placeholder="Boiler Capacity" maxLength={20} />
        </Form.Item>

        <Form.Item label="Select Regular Parameters to Log">
          <Checkbox.Group
            value={selectedParams}
            onChange={setSelectedParams}
            style={{ width: "100%" }}
          >
            <Row gutter={[8, 8]}>
              {BoilerOptions.map((param) => (
                <Col span={12} key={param.value}>
                  <Checkbox value={param.value}>{param.label}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>

        <div style={{ marginTop: 16 }}>
          <b>Add Other Parameters</b>
          {customParams?.map((param, index) => (
            <Row gutter={8} key={index} style={{ marginTop: 8 }}>
              <Col span={10}>
                <Input
                  placeholder="Parameter"
                  value={param.name}
                  maxLength={50}
                  onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                />
              </Col>
              <Col span={10}>
                <Input
                  placeholder="Unit"
                  value={param.unit}
                  maxLength={10}
                  onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                />
              </Col>
              <Col span={4}>
                <Button danger onClick={() => handleDeleteParam(index)} block>
                  ×
                </Button>
              </Col>
            </Row>
          ))}
          <Button type="dashed" onClick={handleAddParam} style={{ marginTop: 12, marginLeft: 5 }}>
            + Add Parameter
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddBoilerModal;
